import React, { useState } from 'react'
import { navigate } from 'gatsby'
import { Form } from 'antd'
import Layout from 'components/layouts/tow-column'
import { Button, Space, TitleAndDescription } from 'components/common'
import {
  CustomerQualificationCard,
  UsageLimitCard,
  DiscountTargetSelectionCard,
  DiscountCancelModal,
} from 'components/discounts'
import {
  DiscountCreateInput,
  DiscountQuery,
} from 'lib/graphql/storeadmin/types-and-hooks'
import { DiscountPercent } from './DiscountPercent'
import DiscountStatus from './DiscountStatus'

type ShowDiscountProps = {
  onSubmit: (values: DiscountCreateInput) => Promise<void>
  onDelete?: () => Promise<void>
  initialData?: DiscountQuery['discount']
  created: boolean
  loading: boolean
}

const onBack = () => navigate('../')

export const ShowDiscount = ({
  onSubmit,
  onDelete,
  initialData,
  created,
  loading,
}: ShowDiscountProps) => {
  type FormValues = DiscountCreateInput
  const [form] = Form.useForm<FormValues>()

  // ディスカウントを適用可能なユーザーリストを生成するためのステート
  const [isEntire, setIsEntire] = useState(
    initialData?.product?.id ? false : true
  ) // カテゴリ
  const [productId, setProductId] = useState(initialData?.product?.id ?? null) // 対象施設
  const [canOverlap, setCanOverlap] = useState(initialData?.canOverlap ?? false) // 重複可否
  // キャンセルモーダル
  const [isCancel, setIsCancel] = useState<boolean>(false)

  // 新規作成と更新で処理を分岐させるためのフラグ
  const isNew = initialData ? false : true

  const handleOpenCancel = () => {
    setIsCancel(true)
  }
  const handleCancelClose = () => setIsCancel(false)

  return (
    <Form
      form={form}
      component="form"
      onFinish={onSubmit}
      name="DiscountsNew"
      layout="vertical"
    >
      <Layout
        title={created ? 'ディスカウントの作成' : 'ディスカウントの詳細'}
        loading={loading}
        onBack={onBack}
      >
        <Layout.Section size={'large'}>
          <Layout.Item>
            <Space direction="vertical">
              <TitleAndDescription
                maxTitleLength={216}
                maxDescriptionLength={1024}
                title={initialData?.title}
                description={initialData?.description}
              />
              <DiscountTargetSelectionCard
                isNew={isNew}
                form={form}
                productId={productId}
                setProductId={setProductId}
                canOverlap={canOverlap}
                setCanOverlap={setCanOverlap}
                isEntire={isEntire}
                setIsEntire={setIsEntire}
              />
              <DiscountPercent discountPercent={initialData?.discountPercent} />
              <CustomerQualificationCard
                form={form}
                customerSelection={initialData?.customerSelection}
                canOverlap={canOverlap}
                isEntire={isEntire}
              />
              <UsageLimitCard usageLimit={initialData?.usageLimit} />
            </Space>
          </Layout.Item>
        </Layout.Section>
        <Layout.Section size={'small'}>
          <Layout.Item>
            {!created && <DiscountStatus status={initialData?.status} />}
          </Layout.Item>
          {!created && (
            <Layout.Item>
              <Space>
                <Form.Item>
                  <Button onClick={() => handleOpenCancel()} type={'primary'}>
                    削除する
                  </Button>
                </Form.Item>
              </Space>
            </Layout.Item>
          )}
        </Layout.Section>

        <Layout.Footer
          left={
            <Space>
              <Button onClick={onBack}>キャンセル</Button>
            </Space>
          }
          right={
            <Space>
              <Form.Item>
                <Button type={'primary'} htmlType={'submit'}>
                  {created ? '保存する' : '更新する'}
                </Button>
              </Form.Item>
            </Space>
          }
        />
      </Layout>
      <DiscountCancelModal
        visible={isCancel}
        onCancel={handleCancelClose}
        onOk={onDelete}
      />
    </Form>
  )
}
